type Props = {
  authenticated: boolean
  authBusy: boolean
  profileName: string
  profileInitials: string
  logout: () => Promise<void>
  toLocalizedPath: (path: string) => string
  labels?: {
    title: string
    account: string
    enter: string
    signedInAs: string
    profile: string
    orders: string
    support: string
    logout: string
    login: string
    signup: string
  }
}

const DEFAULT_LABELS = {
  title: 'Area cliente',
  account: 'Account',
  enter: 'Entra',
  signedInAs: 'Accesso come',
  profile: 'Profilo cliente',
  orders: 'I miei ordini',
  support: 'Assistenza',
  logout: 'Logout',
  login: 'Login cliente',
  signup: 'Crea account',
}

export const HeaderCustomerMenu = ({
  authenticated,
  authBusy,
  profileName,
  profileInitials,
  logout,
  toLocalizedPath,
  labels,
}: Props) => {
  const copy = { ...DEFAULT_LABELS, ...(labels ?? {}) }

  return (
    <div className="group relative">
      <button
        type="button"
        className="ca-theme-transition inline-flex h-11 items-center gap-2 rounded-lg border border-(--color-border-default) bg-(--color-bg-card) px-2.5 text-xs font-semibold text-(--color-text-secondary) shadow-(--shadow-sm) hover:border-(--color-border-strong) hover:text-(--color-text-primary) focus:outline-none focus-visible:ring-2 focus-visible:ring-[color-mix(in_srgb,var(--color-focus-ring)_40%,transparent)]"
        title={copy.title}
        aria-label={copy.title}
        aria-haspopup="menu"
      >
        <span className="grid h-6 w-6 place-items-center rounded-full bg-cyan-100 text-[11px] font-bold text-cyan-700">
          {profileInitials}
        </span>
        <span className="hidden sm:inline">{authenticated ? copy.account : copy.enter}</span>
        <svg viewBox="0 0 24 24" className="h-3.5 w-3.5 fill-none stroke-current stroke-[2]" aria-hidden="true">
          <path d="M6 9l6 6 6-6" />
        </svg>
      </button>
      <div
        className="ca-theme-transition invisible pointer-events-none absolute right-0 top-full z-30 mt-1 min-w-[240px] rounded-2xl border border-(--color-border-default) bg-(--color-bg-card) p-2 opacity-0 shadow-(--shadow-md) transition duration-150 ease-out group-hover:visible group-hover:pointer-events-auto group-hover:opacity-100 group-focus-within:visible group-focus-within:pointer-events-auto group-focus-within:opacity-100"
        role="menu"
      >
        {authenticated ? (
          <>
            <div className="ca-theme-transition rounded-xl bg-(--color-bg-surface-muted) px-3 py-2 text-xs text-(--color-text-muted)">
              {copy.signedInAs} <span className="font-semibold text-(--color-text-secondary)">{profileName}</span>
            </div>
            <a
              href={toLocalizedPath('/dashboard')}
              className="ca-theme-transition mt-2 block rounded-xl px-3 py-2 text-sm font-medium text-(--color-text-secondary) hover:bg-(--color-bg-surface-muted) hover:text-(--color-text-primary)"
            >
              {copy.profile}
            </a>
            <a
              href={toLocalizedPath('/dashboard/shop-orders')}
              className="ca-theme-transition block rounded-xl px-3 py-2 text-sm font-medium text-(--color-text-secondary) hover:bg-(--color-bg-surface-muted) hover:text-(--color-text-primary)"
            >
              {copy.orders}
            </a>
            <a
              href={toLocalizedPath('/dashboard/support-inbox')}
              className="ca-theme-transition block rounded-xl px-3 py-2 text-sm font-medium text-(--color-text-secondary) hover:bg-(--color-bg-surface-muted) hover:text-(--color-text-primary)"
            >
              {copy.support}
            </a>
            <button
              type="button"
              disabled={authBusy}
              onClick={() => {
                void logout()
              }}
              className="mt-1 w-full rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-left text-sm font-semibold text-rose-700 transition hover:border-rose-300 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {copy.logout}
            </button>
          </>
        ) : (
          <>
            <a
              href={toLocalizedPath('/dashboard/login')}
              className="ca-theme-transition block rounded-xl px-3 py-2 text-sm font-medium text-(--color-text-secondary) hover:bg-(--color-bg-surface-muted) hover:text-(--color-text-primary)"
            >
              {copy.login}
            </a>
            <a
              href={toLocalizedPath('/dashboard/signup')}
              className="ca-theme-transition block rounded-xl px-3 py-2 text-sm font-medium text-(--color-text-secondary) hover:bg-(--color-bg-surface-muted) hover:text-(--color-text-primary)"
            >
              {copy.signup}
            </a>
          </>
        )}
      </div>
    </div>
  )
}
